export class LifeCycleConfiguration {
  private key: string;
  private companyFiscalNumber: string;
  private startDate: string;
  private endDate: string;
  private closedDay: number;
  private closedDay2: number;

  setKey(key: string): void {
    this.key = key;
  }

  getKey(): string {
    return this.key;
  }

  setCompanyFiscalNumber(value: string): void {
    this.companyFiscalNumber = value;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setStartDate(value: string): void {
    this.startDate = value;
  }

  getStartDate(): string {
    return this.startDate;
  }

  setEndDate(value: string): void {
    this.endDate = value;
  }

  getEndDate(): string {
    return this.endDate;
  }

  setClosedDay(value: number): void {
    this.closedDay = value;
  }

  getClosedDay(): number {
    return this.closedDay;
  }

  setCloseDay2(value: number) {
    this.closedDay2 = value;
  }

  getCloseDay2(): number {
    return this.closedDay2
  }

  isNew(): boolean {
    return !this.key;
  }
}
